import type { MutableRefObject } from "react";
import { handleListFormat } from "../../../utils/list";
import type { FroalaEditorInstance } from "../types";

export const handleList = (
  editor: FroalaEditorInstance,
  data: any,
  lastRange: MutableRefObject<Range | null>,
  handleAllSelection: () => boolean,
  refresh: (clearSelection?: boolean) => void,
) => {
  const isIcon = data?.type === "icon";
  const type = isIcon ? "icons" : data;
  let icon = {
    unicode: "ee0e",
    icon: "ri-heart-fill",
  };
  if (isIcon) icon = { ...data.data };
  const sel = window.getSelection();
  if (!lastRange.current || !sel) return;
  const range = lastRange.current;
  sel.removeAllRanges();
  sel.addRange(range);
  // Don't select all when removing a list — only the targeted item(s) should be affected
  const isAllSelected = type === "none" ? false : handleAllSelection();
  handleListFormat(editor, type, icon);
  refresh(isAllSelected);
};
